export default __webpack_public_path__ + "static/media/tick-circle.d4aab573.svg";